import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
function FilterOff(_ref) {
  let {
      color = '#788590'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props, {
    id: "icFilterOff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78 3.46 2.22 6 18 21.78v9.96c-.08.58.12 1.2.58 1.66l8.02 8.02c.78.78 2.04.78 2.82 0 .46-.42.66-1.06.58-1.66v-5.98l11.68 11.68 2.54-2.54L30 28.7v-.02l-4-3.98-4-4.02L8.3 7 4.78 3.46zM12.42 6l3.98 4h17.52l-7.7 9.82L30 23.6v-2.1l9.58-12.26c.68-.86.52-2.12-.34-2.8-.38-.28-.8-.44-1.24-.44H12.42zM22 25.78l4 4v5.38l-4-4v-5.38z",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default /*#__PURE__*/memo(FilterOff);